import { connect } from 'react-redux';
import HazardManagementLogPanel from '../../components/HazardManagementLogPanel';
import { domainType } from '../../constants';

import {
  submitHazardManagementLogDispatch,
  enableEditHazardManagementLogDispatch,
  handleEditHazardManagementLogInputChangeDispatch,
  handleAddHazardManagementLogInputChangeDispatch,
  openAddHazardManagementLogDialogDispatch,
  openHazardManagementLogPanelDispatch,
  fetchManagementLogsForTheHazardDispatch,
  openDeleteHazardManagementLogDialogDispatch,
  removeHazardManagementLogsAttachmentEdit,
  fetchExistingAttachmentsForHazardManagementLogsDispatch
} from '../../actions';
import { submitMode } from '../../constants';

function mapStateToProps(state, ownProps) {
  return {
    openPanel: state.hazard.newHazard.showEditHazardPanel,
    hazard: state.hazard.newHazard.item,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    managementLogs: state.hazard.managementLogsForTheHazard.items,
    managementLog: state.hazard.newManagementLog.item,
    isEditManagmentLogEnabled: state.hazard.editManagementLog.enable,
    managementLogBeingEdited: state.hazard.editManagementLog.item,
    openAddHazardManagementLogDialog:
      state.hazard.newManagementLog.openAddHazardManagementDialog,
    openHazardManagementLogPanel:
      state.hazard.newHazard.showHazardManagementLogPanel,
    openDeleteManagementLogDialog:
      state.hazard.toBeDeleteManagementLog.showDeleteHazardManagementLogDialog,
    showDeleteManagementLogDialog:
      state.hazard.toBeDeleteManagementLog.showDeleteHazardManagementLogDialog,
    userId: state.users.user.item,
    allAttachments:
      state.hazard.editManagementLog.item &&
      state.hazard.editManagementLog.item.attachmentFiles
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openHazardManagementLogPanel: (open) => {
      dispatch(openHazardManagementLogPanelDispatch(open));
    },
    fetchManagementLogsForTheHazard: (hazardId) => {
      dispatch(fetchManagementLogsForTheHazardDispatch(hazardId));
    },
    submitManagementLog: (payload, mode, branchId) => {
      dispatch(submitHazardManagementLogDispatch(payload, mode, branchId));
    },
    enableEditManagementLog: (
      enableEditManagementLogMode,
      parentId,
      loggedInUserId
    ) => {
      dispatch(
        enableEditHazardManagementLogDispatch(
          enableEditManagementLogMode,
          parentId
        )
      );
      dispatch(
        fetchExistingAttachmentsForHazardManagementLogsDispatch(
          domainType.HAZARD_LOGS,
          parentId,
          loggedInUserId
        )
      );
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeHazardManagementLogsAttachmentEdit(attachment));
    },
    onHandleAddHazardManagementLogInputChange: (value, inputFieldName) => {
      dispatch(
        handleAddHazardManagementLogInputChangeDispatch(value, inputFieldName)
      );
    },
    onHandleEditHazardManagementLogInputChange: (value, inputFieldName) => {
      dispatch(
        handleEditHazardManagementLogInputChangeDispatch(value, inputFieldName)
      );
    },
    onOpenAddHazardManagementLogDialog: (open) => {
      dispatch(openAddHazardManagementLogDialogDispatch(open));
    },
    onOpenDeleteHazardManagementLogDialog: (open, managementLogId) => {
      dispatch(
        openDeleteHazardManagementLogDialogDispatch(open, managementLogId)
      );
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HazardManagementLogPanel);
